// extracted by mini-css-extract-plugin
export var addButton = "_ns-0";
export var border = "_ns-8";
export var check = "_ns-h";
export var danger = "_ns-6";
export var dropdownContainer = "_ns-1";
export var editModalBody = "_ns-j";
export var footerContainer = "_ns-i";
export var fullWidth = "_ns-a";
export var hide = "_ns-9";
export var icon = "_ns-3";
export var input = "_ns-7";
export var inputFlex = "_ns-b";
export var inputWrapper = "_ns-c";
export var manualFocus = "_ns-5";
export var optionButton = "_ns-4";
export var pillWrapper = "_ns-e";
export var pointer = "_ns-2";
export var showOverflow = "_ns-f";
export var tagsFlex = "_ns-d";
export var xButton = "_ns-g";